export default "__VITE_ASSET__DjXr52xW__"